import { gql } from '@apollo/client'

export const getMediaByUrl = gql`
  query GetMediaByUrl($url: String!) {
    getMediaByUrl(url: $url) {
      media
    }
  }
`
